/* section-sw-password.js — relaunch takedown page.
   Two jobs, both gated on the same prefers-reduced-motion check:
   1. Live countdown to the target ISO date (ticks every 1s). Reduced-motion
      skips the interval entirely and shows the static date line instead
      (CLAUDE.md #4 — no timer created at all under reduced-motion, not just
      a paused one).
   2. Video-loop reveal: clones the <template> markup into the DOM only when
      motion is allowed, same contract as snippets/sw-video-loop.liquid — so
      reduced-motion visitors never fetch the mp4s, only the poster. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function initCountdown() {
    var el = document.querySelector('[data-sw-countdown]');
    if (!el) return;

    var live = el.querySelector('[data-sw-countdown-live]');
    var staticEl = el.querySelector('[data-sw-countdown-static]');
    var target = new Date(el.getAttribute('data-target')).getTime();

    if (reduceMotion || isNaN(target)) {
      if (live) live.hidden = true;
      if (staticEl) staticEl.classList.remove('visually-hidden');
      return;
    }

    var daysEl = el.querySelector('[data-unit="days"]');
    var hoursEl = el.querySelector('[data-unit="hours"]');
    var minutesEl = el.querySelector('[data-unit="minutes"]');
    var secondsEl = el.querySelector('[data-unit="seconds"]');
    var timer;

    function tick() {
      var diff = target - Date.now();
      if (diff <= 0) {
        clearInterval(timer);
        if (live) live.hidden = true;
        if (staticEl) {
          staticEl.classList.remove('visually-hidden');
          staticEl.textContent = "It's live.";
        }
        return;
      }
      var totalSeconds = Math.floor(diff / 1000);
      if (daysEl) daysEl.textContent = String(Math.floor(totalSeconds / 86400));
      if (hoursEl) hoursEl.textContent = pad(Math.floor((totalSeconds % 86400) / 3600));
      if (minutesEl) minutesEl.textContent = pad(Math.floor((totalSeconds % 3600) / 60));
      if (secondsEl) secondsEl.textContent = pad(totalSeconds % 60);
    }

    tick();
    timer = setInterval(tick, 1000);
  }

  function initVideoLoops() {
    if (reduceMotion) return;
    document.querySelectorAll('[data-sw-video-loop]').forEach(function (wrap) {
      var tpl = wrap.querySelector('[data-sw-video-loop-source]');
      if (!tpl) return;
      wrap.insertBefore(tpl.content.cloneNode(true), tpl);
      wrap.removeChild(tpl);
      var poster = wrap.querySelector('img');
      if (poster) poster.hidden = true;
    });
  }

  initCountdown();
  initVideoLoops();
})();
